<template>
  <card>
    <div v-if="$store.state.navs[$options.name]">
      <list
        :columns="columns"
        :modalCreate="modalCreate"
        :removeLink="removeLink"
        :cardLink="cardLink"
        :isUpdate="true"
        :isAdd="true"
        :itemLink="itemLink"
        :setLink="setLink"
        :fields="fields"
        :searchDisable="true"
        @change="change"
        @changeFunction="changeFunction"
      />
    </div>
  </card>
</template>
<script>
import List from "../components/List";

export default {
  name: "Users",
  components: {
    List,
  },
  methods: {
    changeFunction(val) {},
    change(val) {
      this.value = Array.isArray(val) ? val : [val];
    },
  },
  data() {
    return {
      /**START ADD ITEM */
      modalCreate: "user",
      fields: [
        {
          key: "phone",
          label: "Номер телефона (+998XXYYYYYYY)",
          type: "field",
          textType: "phone",
        },
        {
          key: "password",
          label: "Пароль",
          type: "field",
          textType: "password",
        },
        {
          key: "name",
          label: "Полное имя",
          type: "field",
          textType: "text",
        },
        {
          key: "email",
          label: "Email",
          type: "field",
          textType: "email",
        },
      ],
      /** APIs */
      removeLink: "users/delete",
      cardLink: "user",
      itemLink: "users/list",
      setLink: "users/add",
      /** COLUMNS MODEL */
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: true,
          control: false,
          align: "left",
        },
        {
          key: "name",
          title: "Имя",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "email",
          title: "Email",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "phone",
          title: "Телефон",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
        },
      ],
      value: null,
    };
  },
};
</script>
<style>
</style>
